/* eslint-disable jsx-a11y/no-static-element-interactions */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classnames from 'classnames';
import _ from 'lodash';

import Pet from '../../Global/Pet';
import PriceBadge from './PriceBadge';
import NewBadge from './NewBadge';
import { setActivePetAsync } from '../../../actions/activePet';
import { buyPet } from '../../../actions/googleApi';
import getRandom from '../../../utils/getRandom';

class PetItem extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			isActive: this.props.isActive,
			isHover: false,
			isClick: false,
			petAttrs: this.getPetAttrs(),
		};

		this.errorTimeout = null;

		this.setHover = this.setHover.bind(this);
		this.unsetHover = this.unsetHover.bind(this);
		this.setClick = this.setClick.bind(this);
		this.unsetClick = this.unsetClick.bind(this);
		this.getClassNames = this.getClassNames.bind(this);
		this.onClick = this.onClick.bind(this);
	}

	componentWillMount() {
		// On mount, set the purchase state.
		this.setState({
			unpurchased: !this.props.isCollected,
		});
	}

	componentWillReceiveProps(nextProps) {
		// If the new props show that the item has been purchased, trigger our class applier.
		if (nextProps.purchaseSuccess && !this.props.purchaseSuccess) {
			this.applyPurchaseSuccessClasses();
		}
	}

	setHover() {
		this.setState({ isHover: true });
	}

	unsetHover() {
		this.setState({ isHover: false });
	}

	setClick() {
		this.setState({ isClick: true });
	}

	unsetClick() {
		this.setState({ isClick: false });
	}

	applyPurchaseSuccessClasses() {
		this.setState({ purchaseSuccess: true }, () => {
			setTimeout(() => {
				this.setNewActivePet(true);
			}, 900);
		});
	}

	getClassNames() {
		return classnames('pet-picker__list__item', {
			'pet-picker__list__item--is-coming-soon': this.props.isComingSoon,
			'pet-picker__list__item--is-unpurchased': this.state.unpurchased,
			'pet-picker__list__item--purchase-loading': this.props.purchaseLoading,
			'pet-picker__list__item--purchase-success': this.state.purchaseSuccess,
			'pet-picker__list__item--is-active': this.props.moreThanOneCollectedPet ? this.state.isActive : false,
			'pet-picker__list__item--is-offline': this.state.isOffline,
		});
	}

	setNewActivePet(isJustPurchased) {
		const newActivePet = {
			...this.state.petAttrs,
			petType: this.props.petType,
		};

		// If the current cat is special, keep the special name.
		if (this.props.activePetAttrs.name.special) {
			newActivePet.name = this.props.activePetAttrs.name;
		}

		this.props.setActivePet(newActivePet);
		setTimeout(() => {
			this.props.closePetPicker();
		}, 100);
	}

	buyPet() {
		clearTimeout(this.errorTimeout);

		if (!navigator.onLine) {
			this.setState({ isOffline: true });

			this.errorTimeout = setTimeout(() => {
				this.setState({ isOffline: false });
			}, 3000);

			return;
		}

		this.props.buyPet(this.props.sku);
	}

	onClick() {
		if (this.props.isCollected) {
			this.setNewActivePet();
			return;
		}

		this.buyPet();
	}

	getPetAttrs() {
		const petAttrs = getRandom.petOfTypeForPetPicker(this.props.petType.type);

		// If this pet is active it be the same.
		if (this.props.isActive) return this.props.activePetAttrs;
		// Unpurchased pets always like to be pet.
		if (!this.props.isCollected) petAttrs.likesPets = 'likes';

		return petAttrs;
	}

	render() {
		// This item is coming soon, either because it's INACTIVE or it's not in the codebase.
		if (this.props.isComingSoon) {
			return (
				<div className={this.getClassNames()}>
					<Pet
						petType={{ name: 'ComingSoon' }}
						name={{ full: this.props.name }}
					/>
				</div>
			);
		}

		return (
			<div
				className={this.getClassNames()}
				onClick={this.onClick}
				onMouseEnter={this.setHover}
				onMouseLeave={this.unsetHover}
				onMouseDown={this.setClick}
				onMouseUp={this.unsetClick}
			>
				<Pet
					petType={this.props.petType}
					{...this.state.petAttrs}
					name={{ full: this.props.name }}
					kitten={null}
					disablePetting={!this.props.isCollected}
				/>
				<NewBadge
					shouldShow={this.props.isNew}
					isHover={this.state.isHover}
					isClick={this.state.isClick}
				/>
				<PriceBadge
					price={this.props.price}
					isHover={this.state.isHover}
					isClick={this.state.isClick}
					unpurchased={!this.props.isCollected}
					loading={this.props.purchaseLoading}
					success={this.props.purchaseSuccess}
					offline={this.state.isOffline}
				/>
			</div>
		);
	}
}

PetItem.propTypes = {
	petType: PropTypes.shape({
		sku: PropTypes.string,
		type: PropTypes.string,
		name: PropTypes.string,
	}),
	price: PropTypes.number,
	isCollected: PropTypes.bool,
	// isJustPurchased: PropTypes.bool,
	isComingSoon: PropTypes.bool,
	setActivePet: PropTypes.func.isRequired,
	buyPet: PropTypes.func.isRequired,
};

PetItem.defaultProps = {
	petType: {},
	price: null,
	isCollected: true,
	isJustPurchased: false,
	isComingSoon: false,
};

const mapStateToProps = state => ({
	activePetAttrs: state.activePet.active,
});

const mapDispatchToProps = dispatch => ({
	setActivePet: (pet) => {
		dispatch(setActivePetAsync(pet));
	},
	buyPet: (sku) => {
		dispatch(buyPet(sku));
	},
});

export default connect(mapStateToProps, mapDispatchToProps)(PetItem);



// WEBPACK FOOTER //
// ./src/components/Extension/PetPicker/PetItem.js